import { render, staticRenderFns } from "./PublishPage.vue?vue&type=template&id=5cb08b45&scoped=true"
import script from "./PublishPage.vue?vue&type=script&lang=js"
export * from "./PublishPage.vue?vue&type=script&lang=js"
import style0 from "./PublishPage.vue?vue&type=style&index=0&id=5cb08b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb08b45",
  null
  
)

export default component.exports